import React from "react";
import { Button, Sheet, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from "./ui";

// Painel lateral padrão de filtros, aberto pelo funil da barra superior (usePageFilters). O mesmo em
// todas as páginas: título, descrição do que é filtrado, campos, e no rodapé "Limpar filtros"
// (quando a página tem) e "Ver resultados".
export default function FiltersSheet({ open, onOpenChange, description, onClear, clearDisabled = false, children }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="max-w-[min(100vw,440px)] bg-card">
        <SheetHeader className="pr-16">
          <SheetTitle>Filtros</SheetTitle>
          {description ? <SheetDescription>{description}</SheetDescription> : null}
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-6 py-5">{children}</div>
        <SheetFooter className="flex items-center justify-end gap-2">
          {onClear ? (
            <Button variant="outline" onClick={onClear} disabled={clearDisabled}>
              Limpar filtros
            </Button>
          ) : null}
          <Button variant="primary" onClick={() => onOpenChange(false)}>
            Ver resultados
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
